import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom"
import close from "../../../assets/Icons/close-white.png"
import { generateSteps } from "./steps";
import { fontWeight, fontStyle, companyBucket, company_style_details, buttonStyle } from "../../../Utils/tpscanStyle"
import UpperJawDemonstartion from "./upperJawDemonstration";
import { postLogDetails } from "../../../Services/APIs/appDetails";
import teethSides from "../../../Utils/teethSideNames";
import FaceDemoScreen from "../../StarInsurance/Scan/face";

const DemoScreens = (props) => {
    console.log("called here in demoscreens")
    const [cameraSide, setCameraSide] = useState(localStorage.getItem("cameraSide") || "front");
    const steps = generateSteps(cameraSide);
    const [isUpperJawDemonstration, setUpperJawDemonstration] = useState(false)
    const { activeImageSide, setToothPicker, setDemo, setCamera, quickScan, title } = props
    const navigate = useNavigate()
    console.log(steps, activeImageSide, "ssss")

    postLogDetails({
        uid: JSON.parse(localStorage.getItem("usertpi") || "{}").usertpi,
        app: JSON.parse(localStorage.getItem("companyBucket") || "{}").companyBucket,
        payLoad: `viewed ${teethSides[activeImageSide]} teeth demo screen`
    })
    const doneGuide = [
        "Rotate and hold your phone so the selfie camera is just below your chin",
        "Fit your teeth within the template"
    ]

    const gotIt = () => {
        setDemo(false)
        setCamera(true)
    }


    const activeSteps = JSON.parse(localStorage.getItem("activeCaptureSteps") || "{}");
    if (activeSteps?.face && activeImageSide == -1) {
        return <FaceDemoScreen gotIt={gotIt} back={setUpperJawDemonstration} />;
    }

    // if (cameraSide === "front" && steps[activeImageSide]?.title === "Upper jaw") {
    //     return <UpperJawDemonstartion gotIt={gotIt} back={setUpperJawDemonstration} />;
    // }

    return (
        <>
            {
                isUpperJawDemonstration ? <UpperJawDemonstartion gotIt={gotIt} back={setUpperJawDemonstration} /> :

                    <div className="h-full w-full">
                        <div className="z-20 relative h-full w-full text-end text-white ">
                            <button className="p-1" onClick={() => { localStorage.getItem("isAutomated") ? window.history.back() : setToothPicker(true) }}> <img src={close} className="w-7 h-7 m-2" alt="close" /> </button>
                            <h1 className=" text-center text-2xl font-semibold mt-5" style={{ ...fontWeight, ...fontStyle }}>{steps[activeImageSide].title}</h1>
                            <div className="w-full flex flex-col items-center absolute bottom-8 text-center">
                                {
                                    cameraSide === "front" && steps[activeImageSide]?.title === "Upper jaw" ?
                                        <div>

                                            {localStorage.getItem("cameraSide") !== "back" && (
                                                <button
                                                    className="text-center h-12 w-44 bg-white text-black font-semibold rounded mb-3"
                                                    onClick={() => setUpperJawDemonstration(true)}

                                                >
                                                    <span style={{ ...fontStyle }}>
                                                        View steps
                                                    </span>
                                                </button>
                                            )}

                                        </div>
                                        :
                                        <ul className=" list-outside text-white text-start me-5 ms-14 mb-10 list-disc"
                                         >
                                            {
                                                steps[activeImageSide].tips.map((tip, i) => <li key={i}> {tip} </li>)
                                            }
                                        </ul>
                                }
                                <button className="bg-gradient-to-r from-indigo-600 to-indigo-700 hover:from-indigo-700 hover:to-indigo-800 rounded-xl text-white w-full h-14 font-bold text-lg transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105" onClick={gotIt}  >
                                    <span >Got It</span>  </button>
                            </div>
                        </div>
                        <div className="z-10 absolute top-0 w-full h-full">
                            <img src={steps[activeImageSide].image} alt={"front teeth"} className="w-full h-full" />
                        </div>
                    </div>
            }
        </>

    )
}

export default DemoScreens